import React from "react";

import Item from "./Item";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Rating from "../../../components/Rating";

import style from "./style.module.css";

export default function DetailsList(props) {
    const {
        id,
        name = "",
        rating = 0,
        author_name = "",
        description = "",
        total_rating = 0,
        format = null,
    } = props;

    return (
        <>
            <div className={style.firstContentItem}>
                {
                    name !== "" && (
                        <Title tag="h1" transform="uppercase" className="fontTeko">{`${name} ${format ? `(${format})` : ""}`}</Title>
                    )
                }
                {
                    author_name !== "" && (
                        <Title tag="h5" transform="uppercase" className="fontTeko">{`${author_name} (author)`}</Title>
                    )
                }
                {
                    <div className={style.bookRate}>
                        <Rating type="book" id={id} rating={rating} label={false} />
                        {
                            total_rating !== "" && (
                                <Text text={total_rating} />
                            )
                        }
                    </div>
                }
                {
                    description !== "" && (
                        <div className={style.discription}>
                            <Editor text={description} />
                        </div>
                    )
                }
            </div>
            <Item {...props} />
        </>
    )
}